import { render } from "./Button.vue?vue&type=template&id=588531bd&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=588531bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588531bd"]])

export default __exports__